import alt from '../alt';
import emAction from '../actions/emAction';

class emStore {
    constructor() {
        this.bindActions(emAction);
        this.processing = false;
        this.selectedYear = new Date().getFullYear();
        this.selectedMonth = new Date().getMonth();
        this.staffId = "";
        this.mcst = "";
        this.warningMsg = "";
        this.estate = [];
        /*
            {
                mcst: "1234",
                condoName: "condo A",
                incident: 1,
                estate: [
                    { _id: "123", condoName: "Condo A", mcst: "1234", userName: "Ho Kok Liang", date: new Date(), time: new Date(), facility: "Swimming Pool", category: "Tile", status: 0 },
                    { _id: "124", condoName: "Condo A", mcst: "1234", userName: "Ho Kok Liang", date: new Date(), time: new Date(), facility: "Swimming Pool", category: "Tile", status: 1, report: "A001" },
                    { _id: "125", condoName: "Condo A", mcst: "1234", userName: "Ho Kok Liang", date: new Date(), time: new Date(), facility: "Swimming Pool", category: "Tile", status: 0 },
                ]
            },
            {
                mcst: "1235",
                condoName: "condo b",
                incident: 1,
                estate: [
                    { _id: "126", condoName: "Condo b", mcst: "1235", userName: "Tan Kai Lee", date: new Date(), time: new Date(), facility: "Swimming Pool", category: "Tile", status: 0 },
                    { _id: "127", condoName: "Condo b", mcst: "1235", userName: "Tan Kai Lee", date: new Date(), time: new Date(), facility: "Swimming Pool", category: "Tile", status: 1, report: "A002" },
                ]
            }
        */
    }
    onWarningMsg(data) {
        this.warningMsg = data;
    }
    onProcessing(data) {
        this.processing = data;
    }
    onStaffId(data) {
        this.staffId = data.staffId;
    }
    onSelectMonth(data) {
        this.selectedYear = data.selectedYear;
        this.selectedMonth = data.selectedMonth;
    }
    onMcst(data) {
        this.mcst = data.mcst;
    }
    onEstateSuccess(data) {
        this.estate = data;
        this.onSortByStatus();
    }
    onShouldListShow(data) {
        this.estate[data].shouldListShow = !this.estate[data].shouldListShow;
    }
    onSortByStatus(data) {

        let len = this.estate.length;
        for (let i = 0; i < len; i++) {
            this.estate[i].estate.sort(function (a, b) {
                if (typeof data != 'number') {
                    return (new Date(b.date).getTime() - new Date(a.date).getTime());
                } else if (data == 0) {
                    if (a.status == b.status && a.status == 0) {
                        return (new Date(b.date).getTime() - new Date(a.date).getTime());
                    } else if (a.status == 0) {
                        return -1;
                    } else if(a.status != 0 && b.status != 0){
                        return (new Date(b.date).getTime() - new Date(a.date).getTime());
                    } else {
                        return 1;
                    }
                } else if (data == 1) {
                    if (a.status == b.status && a.status == 1) {
                        return (new Date(b.date).getTime() - new Date(a.date).getTime());
                    } else if (a.status == 1) {
                        return -1;
                    } else if(a.status != 1 && b.status != 1){
                        return (new Date(b.date).getTime() - new Date(a.date).getTime());
                    } else {
                        return 1;
                    }
                } else {
                    if (a.status == b.status && a.status == 2) {
                        return (new Date(b.date).getTime() - new Date(a.date).getTime());
                    } else if (a.status == 2) {
                        return -1;
                    } else if(a.status != 2 && b.status != 2){
                        return (new Date(b.date).getTime() - new Date(a.date).getTime());
                    } else {
                        return 1;
                    }
                }
            });
        }
    }
}
export default alt.createStore(emStore, 'emStore');


// WEBPACK FOOTER //
// ./app/stores/emStore.js